export const countries = [
  "",
  "Brussels_Belgium",
  "Paris_France",
  "London_UK",
  "Dublin_Ireland",
  "Berlin_Germany",
  "Barcelona_Spain",
];
